import React from "react";
import { StatusBadge } from "../../../../shared/components/badges/StatusBadge";
import { ExpandedAccordion } from "../../../../shared/components/ui/ExpandedAccordion";

const CenterExpandRow = ({ item }) => {
  const sections = [
    {
      id: "basic",
      title: "Basic Information",
      fields: [
        { label: "Vaccination Center Name", value: item.name || "—" },
        { label: "Country", value: item.country || "—" },
        { label: "State", value: item.state?.name || item.state || "—" },
        { label: "District", value: item.district?.name || "—" },
        { label: "Taluka", value: item.taluka?.name || "—" },
        { label: "Village", value: item.village?.name || "—" },
        { label: "Address", value: item.address || "—", isLong: true },
        // { label: "Landmark", value: item.landmark || "—" },
        { label: "Pincode", value: item.pincode || "—" },
        { label: "Status", value: item.status ? <StatusBadge status={item.status} /> : "—" },
      ],
    },
    {
      id: "contact",
      title: "Contact Information",
      fields: [
        { label: "Phone Number", value: item.phone || "—" },
        { label: "Email", value: item.email || "—" },
        { label: "License Number", value: item.licenseNumber || "—" },
        { label: "Opening Hours", value: item.openingHours || "—" },
        { label: "Facilities", value: item.facilities || "—", isLong: true },
        // { label: "Notes", value: item.notes || "—", isLong: true },
        {
          label: "Created Date",
          value: item.createdAt
            ? new Date(item.createdAt).toLocaleDateString("en-US", {
                month: "short",
                day: "numeric",
                year: "numeric",
              })
            : "—",
        },
      ],
    },
  ];

  return <ExpandedAccordion sections={sections} />;
};

export default CenterExpandRow;
